import { render, staticRenderFns } from "./SearchToggleCheckbox.vue?vue&type=template&id=1f2a7154"
import script from "./SearchToggleCheckbox.vue?vue&type=script&lang=js"
export * from "./SearchToggleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports